import { Entity } from '../../../../../@Api/Model/Implementation/Entity';

export function getMapViewDivId(entity: Entity) : string
{
    return `MapViewDivId_${entity.uuid}`;
}
